import styled from "styled-components";
export const Styles = styled.div`
.simple-details{
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-align: start;
  gap: 20px;
  padding-bottom : 10px;
  border-bottom:1px solid #000000;
  .item {
    display: flex;
    gap: 5px;
    align-items: center;
    .title {
      font-weight: 600;
      font-size: 18px;
      color: #5f5f5f;
    }
    .data {
      font-weight: 500;
      font-size: 18px;
      a{
        color: #3F78E0;
      }
    }
  }
  }
  .advertising-show{
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-align: start;
  gap: 20px;
  padding-bottom : 10px;
  border-bottom:1px solid #000000;
  .item {
    display: flex;
    gap: 5px;
    align-items: center;
    .title {
      font-weight: 600;
      font-size: 18px;
      color: #5f5f5f;
    }
    .data {
      font-weight: 500;
      font-size: 18px;
      a{
        color: #3F78E0;
      }
    }
  }
`;
